import axios from './axios'

class Comment {
  commitComment(params) {
    let url = '/Comments/Comments/CreateComments'
    return axios.post(url, params)
  }

  getComments(params = {}) {
    let url = '/Comments/Comments/GetComments'
    return axios.post(url, params)
  }

  getSubComments(params = {}) {
    let url = '/Comments/Comments/GetSubComments'
    return axios.post(url, params)
  }

  deleteComment(commentId = '') {
    let url = '/Comments/Comments/DeleteComment'
    let params = {
      commentId: commentId
    }
    return axios.post(url, params)
  }

  getCommentList(params = {}) {
    let url = '/Comments/Comments/List'
    return axios.post(url, params)
  }
  //分页获取直播评论
  getLiveComments(params = {}) {
    let url = '/Comments/Api/Page'
    return axios.post(url, params)
  }
  //直播评论
  commitLiveComment(params = {}) {
    let url = '/Comments/Api/Comment'
    return axios.post(url, params)
  }
}

export default new Comment()
